import axios from 'axios'
import config from './config'
// import Cookies from 'js-cookie'
import router from '@/router'
import { Message } from 'element-ui' // Loading
import { loginUrl, generateKey } from '@/utils/global'
import * as encryptUtils from '../utils/encrypt'
import qs from 'qs'

// 使用vuex做全局loading时使用
// import store from '@/store'

export default function $axios(options) {
    const token = sessionStorage.getItem('access-token')
    token ? config.headers['access-token'] = token : delete config.headers['access-token']
    return new Promise((resolve, reject) => {
        var baseUri
        if (process.env.HOST.indexOf('192') > -1) {
            baseUri = process.env.HOST
        } else {
            const env = process.env['NODE_ENV']
            if (options.url === '/common/image/upload' || options.url === '/common/file/upload') {
                var s = 'base'
                env === 'development' ? s = 'testbase' : ''
                baseUri = `${process.env.HOST.replace('${application}', s)}`
            } else if (options.url.split('/')[1] !== 'logout') {
                // 获取子系统的域名，截取路径的第二个地址
                let app = options.url.split('/')[2]
                // options.url.split('/')[2] === 'data' ? app = 'wish' : ''
                env === 'development' ? app = `test${app}` : ''
                baseUri = process.env.HOST.replace('${application}', app)
            } else {
                var d = 'admin'
                env === 'development' ? s = 'testadmin' : ''
                baseUri = `${process.env.HOST.replace('${application}', d)}`
            }
            if (options.url === '/api/sms/user/code') {
                let admin = 'user'
                env === 'development' ? admin = `test${admin}` : admin
                baseUri = process.env.HOST.replace('${application}', admin)
            }
        }
        const instance = axios.create({
            baseURL: baseUri,
            headers: config.headers,
            timeout: config.timeout,
            withCredentials: config.withCredentials,
            paramsSerializer: (params) => qs.stringify(params, { indices: false })
        })
        // request 拦截器
        instance.interceptors.request.use(
            config => {
                // let token = Cookies.get('access-token')
                // console.log(token)
                // 1. 请求开始的时候可以结合 vuex 开启全屏 loading 动画
                // console.log(store.state.loading)
                // Loading.service({body: true, lock: true, text: 'Loading...', customClass: 'mask'})
                // 2. 带上token
                // if (token) {
                //   config.headers.token = token
                // } else {
                // 重定向到登录页面
                // router.push(loginUrl)
                // console.log('重定向到登录页面...')
                // }

                // 去掉加密
                // 3. 根据请求方法，序列化传来的参数，根据后端需求是否序列化
                // get请求需要传入params参数，其他请求使用data即可
                // let key = generateKey()
                // let iv = generateKey()
                if (config.method === 'get') {
                    config.params = config.data
                    // key = encryptUtils.encryptRsa(key)
                    // iv = encryptUtils.encryptRsa(iv)
                }
                // else {
                //     if (config.url !== '/common/image/upload') {
                //         const data = JSON.stringify(config.data)
                //         const content = encryptUtils.encryptAes(data, key, iv)
                //         key = encryptUtils.encryptRsa(key)
                //         iv = encryptUtils.encryptRsa(iv)
                //         config.data = encodeURIComponent(content)
                //     }
                // }
                // if (config.url !== '/common/image/upload') {
                //     config.headers['request-id'] = key
                //     config.headers['request-iv'] = iv
                // }
                return config
            },
            error => {
                // 请求错误时
                console.log('request请求错误:', error)
                // 1. 判断请求超时
                if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
                    console.log('timeout请求超时')
                    Message.error({ message: error.response })
                    return
                    // return service.request(originalRequest);// 再重复请求一次
                }
                // 2. 需要重定向到错误页面
                const errorInfo = error.response
                console.log(errorInfo)
                if (errorInfo) {
                    error = errorInfo.data // 页面那边catch的时候就能拿到详细的错误信息,看最下边的Promise.reject
                    const errorStatus = errorInfo.status // 404 403 500 ...
                    router.push({
                        path: `/${errorStatus}`
                    })
                }
                Message.error({ message: errorInfo })
                return Promise.reject(error) // 在调用的那边可以拿到(catch)你想返回的错误信息
            }
        )

        // response 拦截器
        instance.interceptors.response.use(
            response => {
                // Loading.service().close()
                let data
                // const requestId = response.headers['request-id']
                // const requestIv = response.headers['request-iv']
                // IE9时response.data是undefined，因此需要使用response.request.responseText(Stringify后的字符串)
                if (response.data === undefined) {
                    data = JSON.parse(response.request.responseText)
                } else {
                    data = response.data
                    if (response.config.url.split('lpswish.com')[1] !== '/common/image/upload') {
                        if (data.data) {
                            // const key = encryptUtils.decryptRsa(requestId)
                            // const iv = encryptUtils.decryptRsa(requestIv)
                            // const en = decodeURIComponent(data.data)
                            // const content = encryptUtils.decryptAes(en, key, iv)
                            // data.data = JSON.parse(content)
                        }
                    }
                }
                // 根据返回的code值来做不同的处理
                switch (data.code) {
                    case 401:
                        sessionStorage.removeItem('user')
                        sessionStorage.removeItem('access-token')
                        router.push(loginUrl)
                        break
                    case 500:
                        // console.log('服务器异常')
                        Message.error({ message: data.message })
                        break
                    default:
                }
                // 请求返回失败
                if (data.success && !data.success) {
                    Message.error({ message: data.message })
                }
                // 若不是正确的返回code，且已经登录，就抛出a错误
                // const err = new Error(data.desc)
                // err.data = data
                // err.response = response
                // throw err

                return data
            },
            err => {
                // Loading.service().close()
                if (err && err.response) {
                    switch (err.response.status) {
                        case 400:
                            err.message = '请求错误'
                            break
                        case 401:
                            err.message = '未授权，请登录'
                            break
                        case 403:
                            err.message = '拒绝访问'
                            break
                        case 404:
                            err.message = `请求地址出错: ${err.response.config.url}`
                            break
                        case 408:
                            err.message = '请求超时'
                            break
                        case 500:
                            err.message = '服务器内部错误'
                            break
                        case 501:
                            err.message = '服务未实现'
                            break
                        case 502:
                            err.message = '网关错误'
                            break
                        case 503:
                            err.message = '服务不可用'
                            break
                        case 504:
                            err.message = '网关超时'
                            break
                        case 505:
                            err.message = 'HTTP版本不受支持'
                            break
                        default:
                    }
                }
                Message.error({ message: err.message })
                return Promise.reject(err) // 返回接口返回的错误信息
            }
        )

        // 请求处理
        instance(options).then(res => {
            resolve(res)
            return false
        }).catch(error => {
            reject(error)
        })
    })
}



// WEBPACK FOOTER //
// ./src/http/axios.js